import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-4" }

import { ref, watch } from 'vue'
import { Tracking } from '../../../api/v2/models/activity_data'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserTrackingChangeDialog',
  props: {
    tracking: {},
    update: { type: Function }
  },
  setup(__props: any) {

const props = __props

const hours = ref(0)
const minutes = ref(0)
const dialog = ref(false)

watch(() => props.tracking, (newTracking) => {
  if (newTracking) {
    hours.value = newTracking.timeValue.hours
    minutes.value = newTracking.timeValue.minutes
  }
}, { immediate: true })

const numberRules = [(v: any) => v !== null && v !== undefined && v !== '' || '値入力必要']

const onUpdate = async () => {
  if (props.update) {
    await props.update(props.tracking, hours.value * 60 * 60 + minutes.value * 60)
  }
  dialog.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
    "max-width": "600",
    transition: "dialog-bottom-transition"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({
        size: "small",
        color: "indigo",
        variant: "outlined"
      }, props), {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" 変更 ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("トラッキング時間変更", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_text_field, {
                  modelValue: hours.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hours).value = $event)),
                  modelModifiers: { number: true },
                  rules: numberRules,
                  label: "時間",
                  type: "number",
                  variant: "outlined",
                  density: "comfortable",
                  required: ""
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: minutes.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((minutes).value = $event)),
                  modelModifiers: { number: true },
                  rules: numberRules,
                  label: "分",
                  type: "number",
                  variant: "outlined",
                  density: "comfortable",
                  required: ""
                }, null, 8 /* PROPS */, ["modelValue"])
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_actions, { class: "justify-end pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (dialog.value = false))
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" キャンセル ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                onClick: onUpdate
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" 更新 ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})